import React from "react";
import { useGetAssignmentsQuery } from "../../../features/assignments/assignmentsApi";
import Error from "../../ui/Error";
import SingleAssignment from "./SingleAssignment";

export default function AssignmentList() {
  const {
    data: assignments,
    isLoading,
    isError,
    error,
  } = useGetAssignmentsQuery() || {};

  let content = null;

  if (isLoading) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        Loading...
      </div>
    );
  } else if (!isLoading && isError) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && assignments?.length === 0) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        No Videos Found!
      </div>
    );
  } else if (!isLoading && !isError && assignments?.length > 0) {
    content = assignments.map((assignment) => {
      return <SingleAssignment key={assignment.id} assignment={assignment} />;
    });
  }
  return (
    <div className="overflow-x-auto mt-4">
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Title</th>
            <th className="table-th">Video Title</th>
            <th className="table-th">Mark</th>
            <th className="table-th">Action</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-600/50">{content}</tbody>
      </table>
    </div>
  );
}
